import React, { useState, useEffect, } from 'react';
import { useParams } from 'react-router-dom';
import Magnifier from 'react-magnifier';
import axios from 'axios';
import logo from '../../assets/report/logo.png';
import qr from '../../assets/report/qr.png';
import device from '../../assets/report/device.png';
import network from '../../assets/report/network.png';
import health from '../../assets/report/health.png';
import img1 from '../../assets/report/img1.png';
import img2 from '../../assets/report/img2.png';
import a from '../../assets/report/a.png';
import globe from '../../assets/report/globe.png';
import mob from '../../assets/report/mob.png';
import ins from '../../assets/report/ins.png';
import lin from '../../assets/report/lin.png';
import fac from '../../assets/report/fac.png';
import pin from '../../assets/report/pin.png';
import goog from '../../assets/report/goog.png';
import avatar from '../../assets/profile.png';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import QRCode from "react-qr-code";

import loadingGif from './assets/report-loading.gif';

import './Report.css';


function WebHookReport() {
  const { id } = useParams();
  const [reportData, setReportData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [imagesLoaded, setImagesLoaded] = useState(true);
  const [carouselImages, setCarouselImages] = useState([]);
  const [loadedImages, setLoadedImages] = useState(0);
  const [totalImages, setTotalImages] = useState(0);
  const [loading, setLoading] = useState(true);

  console.log('DEVICE BATTERY HEALTH', carouselImages)

  //Destrcutring the Report endpoint data
  const {
    report: {

      reportid,
      starttime,
      finishtime,
      IMEI,
      serialnumber,
      deviceid,
      Manufacturer,
      Model,
      os,
      operator,
      reportstatus,
      reportresult,
      reporttype,
      action,
      value,
      grade,
    } = {},
    extra: {
      json: {
        AnalystInfo: {
          AnalystApplicationVersion,
          AnalystId,
          AssetManagement,
          DeviceAnalystVersion,
          FinishDate,
          FinishTime,
          LicenseId,
          LicenseReportMode,
          ProfileName,
          Result,
          SiteID,
          StartDate,
          StartTime,
          Status,
          TestCaseFails,
          UniqueLicenseId,
          UserName,
          WindowsPCName
        } = {},
        DeviceInfo: {
          ANumber,
          BaseBandVersion,
          BuildVersion,
          CPU,
          CountryOrigin,
          CpuName,
          CpuSpeed,
          DecimalMEID,
          DeviceColor,
          DeviceEnclosureColor,
          DeviceId,
          ECID,
          EID,
          FMIP,
          HandsetMemorySize,
          HardwareModel,
          HardwarePlatform,
          IMEI2,
          LCDResolution,
          LCDSize,
          MDMStatus,
          MLBSerialNumber,
          ManufactureDate,
          ModelNumber,
          OperatingSystem,
          OriginalProductVersion,
          ProductType,
          ProductVersion,
          RAM,
          RegionInfo,
          Rooted,
          SerialNumber,
          SoftwareBuild,
          BatteryInfo: [{
            BatteryActualDesignCapacity,
            BatteryCycleCount,
            BatteryDesignCapacity,
            BatteryFullChargeCapacity,
            BatteryGrading,
            BatteryHealth,
            BatteryManufacturerDate,
            BatteryOverallPercentage,
            BatterySerial,
            BatteryTemp
          } = {}
          ] = [],
        } = {},
        Testcases: [

        ] = [],


        CustomInfo: {
          CustomName1,
          CustomValue1
        } = {},
        PartsReplaced,
      } = {},
    } = {},
  } = reportData?.data || {};



  const renderImage = (image) => (
    <Magnifier
      src={image.original}
      mgShape="circle"
      mgShowOverflow={false}
      mgWidth={200}
      mgHeight={200}
      
      zoomFactor={1.5}
      alt="Device image"
      style={{ width: "100%" }}
      onError={(e) => {
        e.target.src = '';
        e.target.alt = `Image not available for ${image.alt}`;
        setImagesLoaded(false);
      }}
    />
  );

  const imei = IMEI;
  useEffect(() => {
    if (!imei) {
      setLoading(false)
      return
    };
    setLoading(true);
    const imageFilenames = [
      'Back.jpg',
      'Behind.jpg',
      'Font_LightAngle1.jpg',
      'Font_LightAngle2.jpg',
      'Font_LightAngle3.jpg',
      'Font_LightAngle4.jpg',
      'Font_LightAngle5.jpg',
      'Font_LightAngle6.jpg',
      'Font_LightAngle7.jpg',
      'Font_LightAngle8.jpg',
      'Front.jpg',
    ];

    const orderedImages = new Array(imageFilenames.length);
    let checkedCount = 0;
    const totalImages = imageFilenames.length;

    imageFilenames.forEach((filename, index) => {
      const baseName = filename.replace('.jpg', '');
      const webpUrl = `https://report.gearvu.io/kiosk-image/downloaded_files/${imei}/${baseName}.webp`;
      const jpgUrl = `https://report.gearvu.io/kiosk-image/downloaded_files/${imei}/${baseName}.jpg`;
      const tempImage = new Image();
      tempImage.onload = () => {
        orderedImages[index] = {
          original: webpUrl,
          fallback: jpgUrl,
          thumbnail: webpUrl,
          alt: `Image of ${baseName.replace(/_/g, ' ')}`,
        };
        checkedCount++;
        if (checkedCount === totalImages) {
          setCarouselImages(orderedImages.filter(Boolean));
          setLoading(false);
        }
      };
      tempImage.onerror = () => {
        const fallbackImage = new Image();
        fallbackImage.onload = () => {
          orderedImages[index] = {
            original: jpgUrl,
            fallback: jpgUrl,
            thumbnail: jpgUrl,
            alt: `Image of ${baseName.replace(/_/g, ' ')}`,
          };
          checkedCount++;
          if (checkedCount === totalImages) {
            setCarouselImages(orderedImages.filter(Boolean));
            setLoading(false);
          }
        };
        fallbackImage.onerror = () => {
          checkedCount++;
          if (checkedCount === totalImages) {
            setCarouselImages(orderedImages.filter(Boolean));
            setLoading(false);
          }
        };
        fallbackImage.src = jpgUrl;
      };

      tempImage.src = webpUrl;
    });
  }, [imei]);


  const handleScreenChange = (isFullScreen) => {
    setIsFullscreen(isFullScreen);
  };


  useEffect(() => {
    if (!id) {
      setError('No report ID provided');
      return;
    }

    const fetchReport = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(`api/webhook/report/${id}`);
        setReportData(response.data);
      } catch (err) {
        setError('Failed to fetch report data');
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchReport();
  }, [id]);

  // Destructuring the Testcases data from reportData
  const testCases = reportData?.data?.extra?.json?.Testcases || [];

  // Extract the PartsReplaced object
  const parts = PartsReplaced ? PartsReplaced.iOS : {};

  // Function to format camelCase to space-separated words with manual mapping for ALL CAPS words
  const formatTestCaseName = (name) => {
    if (!name) return 'N/A'; // Handle undefined or null cases

    // Manual mapping for ALL CAPS test cases
    const manualMapping = {
      DEVICEBEZELCOS: "Device Bezel Cosmetic",
      EARPHONEJACKCOS: "Earphone Jack Cosmetic",
      HOMEKEYCOS: "Home Key Cosmetic",
      POWERKEYCOS: "Power Key Cosmetic",
      REARCASINGCOS: "Rear Casing Cosmetic",
      SIMTRAYCOS: "Sim Tray Cosmetic",
      TOUCHID: "Touch ID",
      USBPORTCOS: "USB Port Cosmetic",
    };

    // Check if the name matches a key in the manual mapping
    if (manualMapping[name]) {
      return manualMapping[name];
    }

    // Default formatting for camelCase or PascalCase
    const formattedName = name.replace(/([a-z])([A-Z])/g, '$1 $2'); // Split camelCase or PascalCase
    return formattedName.charAt(0).toUpperCase() + formattedName.slice(1); // Capitalize the first letter
  };

  // Function to format the result
  const formatResult = (result) => {
    return result === "NOT SUPPORTED ON DEVICE" ? "NOT SUPPORTED" : result;
  };

  const gradeLabels = {
    1: "Excellent",
    2: "Better",
    3: "Good"
  };



  return (
    <div className="App">
      <header className="App-header">
        <div className="container">
          <div className="row d-flex align-items-center justify-content-between">

            <div className="col-md-4 text-start">
              <a
                className="App-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={logo} className="App-logo" alt="logo" />
              </a>
            </div>

            <div className="col-md-4 text-center">
              <button className="phone-value-button">
                Cosmetic Condition: {gradeLabels[grade] || "N/A"}
              </button>
            </div>

            <div className="col-md-4 text-end">
              <p>
                DEVICE INSPECTION{" "}
                <span
                  className="status"
                  style={{
                    background: reportstatus === "Completed" ? "#28a745" : "#CE2E28",
                    border: `2px solid ${reportstatus === "Completed" ? "#28a745" : "#CE2E28"}`
                  }}
                >
                  {reportstatus}
                </span>
              </p>

            </div>
          </div>
        </div>
      </header>

      <section className='sec-1'>
        <div className='container'>
          <div className='row align-items-center'>
            <div className='col-md-6'>
              <div className="f-left">
                <div className="row align-items-center">
                  <div className="col-md-9">
                    <ul>
                      <li>Report ID</li>
                      <li>{reportid}</li>
                      <li>Start Time</li>
                      <li>{starttime}</li>
                      <li>Finish Time</li>
                      <li>{finishtime}</li>
                      <li>Serial Number</li>
                      <li>{serialnumber}</li>
                      <li>Device ID</li>
                      <li>{deviceid}</li>
                    </ul>
                  </div>

                  <div className="col-md-3">
                    <QRCode
                      size={256}
                      style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                      value={`https://report.gearvu.io/report/${reportid}`}

                    />
                  </div>
                </div>
              </div>
            </div>

            <div className='col-md-6'>
              <div className="row">
                <div className="col-md-6">
                  <ul>
                    <li><strong>ANALYST</strong></li>
                    <li>ID: <strong>{formatTestCaseName(AnalystId || 'N/A')}</strong></li>
                    <li>Application Version: <strong>{formatTestCaseName(AnalystApplicationVersion || 'N/A')}</strong></li>
                    <li>Device Version: <strong>{formatTestCaseName(DeviceAnalystVersion || 'N/A')}</strong></li>
                    <li>License ID: <strong>{formatTestCaseName(LicenseId || 'N/A')}</strong></li>
                    <li>Site ID: <strong>{formatTestCaseName(SiteID || 'N/A')}</strong></li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <ul>
                    <li><strong>REPORT</strong></li>
                    <li>Result: <strong>{formatTestCaseName(reportresult || 'N/A')}</strong></li>
                    <li>Type: <strong>{formatTestCaseName(reporttype || 'N/A')}</strong></li>
                    <li>Action: <strong>{formatTestCaseName(action || 'N/A')}</strong></li>

                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      <section className="sec-2">
        <div className="container">
          <div className="row pt-3">
            <div className="col-md-4 px-3">
              <div className="card-inner">
                <img src={device} className="img-fuild" alt="device" />
                <h2>
                  DEVICE <br />
                  INFORMATION
                </h2>

                <div className="row">
                  <div className="col-md-12">
                    <ul className="text-start">
                      <li><strong>Model</strong></li>
                      <li>{Model || 'N/A'}</li>
                      <li><strong>IMEI</strong></li>
                      <li>{imei || 'N/A'}</li>
                      <li><strong>Memory</strong></li>
                      <li>{HandsetMemorySize || 'N/A'}</li>
                      <li><strong>RAM</strong></li>
                      <li>{RAM || 'N/A'}</li>
                      <li><strong>CPU</strong></li>
                      <li>{CpuName || 'N/A'}</li>
                      <li><strong>Color</strong></li>
                      <li>{DeviceColor || 'N/A'}</li>
                      <li><strong>Serial #</strong></li>
                      <li>{serialnumber || 'N/A'}</li>
                      <li><strong>Model #</strong></li>
                      <li>{ModelNumber || 'N/A'}</li>
                      {/* <li><strong>Manufacturer</strong></li> */}

                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4 px-3">
              <div className="card-inner">
                <img src={network} className="img-fuild" alt="network" />
                <h2>NETWORK COMPATABILITY</h2>
                <div className="row">
                  <div className="col-md-12">
                    <ul className="text-start">
                      <li><strong>Baseband Version</strong></li>
                      <li>{BaseBandVersion || 'N/A'}</li>
                      <li><strong>Build Version</strong></li>
                      <li>{BuildVersion || 'N/A'}</li>
                      <li><strong>Country Origin</strong></li>
                      <li>{CountryOrigin || 'N/A'}</li>
                      <li><strong>IMEI 2</strong></li>
                      <li>{IMEI2 || 'N/A'}</li>
                      <li><strong>ECID</strong></li>
                      <li>{ECID || 'N/A'}</li>
                      <li><strong>Region</strong></li>
                      <li>{RegionInfo || 'N/A'}</li>
                      <li><strong>Rooted</strong></li>
                      <li>{Rooted || 'N/A'}</li>
                      <li><strong>Manufacture Date</strong></li>
                      <li>{ManufactureDate
                        || 'N/A'}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-4 px-3">
              <div className="card-inner">
                <img src={health} className="img-fuild" alt="health" />
                <h2>DEVICE BATTERY HEALTH</h2>
                <div className="row">
                  <div className="col-md-12">
                    <ul className="text-start">
                      <li><strong>Design Capacity</strong></li>
                      <li>{BatteryDesignCapacity || 'N/A'}</li>
                      <li><strong>Cycle Count</strong></li>
                      <li>{BatteryCycleCount || 'N/A'}</li>
                      <li><strong>Grading</strong></li>
                      <li>{BatteryGrading || 'N/A'}</li>
                      <li><strong>Health</strong></li>
                      <li>{BatteryHealth || 'N/A'}</li>
                      <li><strong>Manufacture Date</strong></li>
                      <li>{BatteryManufacturerDate || 'N/A'}</li>
                      <li><strong>Percentage</strong></li>
                      <li>{BatteryOverallPercentage || 'N/A'}</li>
                      <li><strong>Serial</strong></li>
                      <li>{BatterySerial || 'N/A'}</li>
                      <li><strong>Temperature</strong></li>
                      <li>{BatteryTemp || 'N/A'}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Images */}
      <section className="sec-3">
        <div className="container">
          <div className="row pt-3">
            <div className="img-box">


              {loading ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'auto' }}>
                  <img src={loadingGif} alt="Loading..." />
                </div>
              ) : carouselImages?.length === 0 ? (
                <div className="alert alert-danger d-flex align-items-center" role="alert">
                  <i className="fa-solid fa-triangle-exclamation" style={{ fontSize: '24px', marginRight: '10px' }}></i>
                  <span>Image data missing or incomplete. No device images found or processed.</span>
                </div>
              ) : (
                <ImageGallery
                  items={carouselImages?.map((image) => ({
                    ...image,
                    renderItem: () => {
                      const isFullscreen = document.fullscreenElement !== null;
                      return (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                          }}
                        >
                          <img
                            src={image.original}
                            alt={image.alt}
                            onError={(e) => {
                              e.target.src = image.fallback;
                            }}
                            style={
                              isFullscreen
                                ? {
                                  maxWidth: "90%",
                                  maxHeight: "90%",
                                  objectFit: "contain",
                                }
                                : {
                                  maxWidth: "65%",
                                  maxHeight: "80%", // fits above thumbnails
                                  objectFit: "contain",
                                }
                            }
                          />
                        </div>
                      );
                    },
                  }))}
                  
                  showThumbnails={true}
                  showFullscreenButton={true}
                />
              )}

            </div>
          </div>
        </div>
      </section>

      <section className="sec-4">
        <div className="container">
          <div className="row py-5">
            <div className="col-md-4 px-3">
              <div className="card-inner">
                <h2>SOFTWARE & DIAGNOSTICS</h2>
                <div className="row">
                  <div className="col-md-12">
                    <ul className="text-start">
                      <li><strong>OS</strong></li>
                      <li>{os || 'N/A'}</li>
                      <li><strong>Product Version</strong></li>
                      <li>{ProductVersion || 'N/A'}</li>
                      <li><strong>Software Build</strong></li>
                      <li>{SoftwareBuild || 'N/A'}</li>
                      <li><strong>A Number</strong></li>
                      <li>{ANumber || 'N/A'}</li>
                      <li><strong>Model</strong></li>
                      <li>{HardwareModel || 'N/A'}</li>
                      <li><strong>Platform</strong></li>
                      <li>{HardwarePlatform || 'N/A'}</li>
                      <li><strong>Type</strong></li>
                      <li>{ProductType || 'N/A'}</li>
                      <li><strong>Version</strong></li>
                      <li>{ProductVersion || 'N/A'}</li>
                      <li><strong>MLB Serial</strong></li>
                      <li>{MLBSerialNumber || 'N/A'}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-4 px-3">
              <div className="card-inner">
                <h2>MOBILE DEVICE MANAGEMENT(MDM)</h2>
                <div className="row">
                  <div className="col-md-12">
                    <ul className="text-start">
                      <li><strong>MDM Status</strong></li>
                      <li>{MDMStatus || 'N/A'}</li>
                      <li><strong>MLB Serial</strong></li>
                      <li>{MLBSerialNumber || 'N/A'}</li>
                      <li><strong>Date</strong></li>
                      <li>{ManufactureDate || 'N/A'}</li>
                      <li><strong>Product</strong></li>
                      <li>{OriginalProductVersion || 'N/A'}</li>
                      <li><strong>Product Type</strong></li>
                      <li>{ProductType || 'N/A'}</li>
                      <li><strong>Rooted</strong></li>
                      <li>{Rooted || 'N/A'}</li>
                      <li><strong>Software</strong></li>
                      <li>{SoftwareBuild || 'N/A'}</li>
                      <li><strong>Base Band</strong></li>
                      <li>{BaseBandVersion || 'N/A'}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-4 px-3">
              <div className="card-inner">
                <h2>ADDITIONAL INFORMATION</h2>
                <div className="row">
                  <div className="col-md-12">
                    <ul className="text-start">
                      <li><strong>CPU</strong></li>
                      <li>{CPU || 'N/A'}</li>
                      <li><strong>CPU Speed</strong></li>
                      <li>{CpuSpeed || 'N/A'}</li>
                      <li><strong>Decimal MEID</strong></li>
                      <li>{DecimalMEID || 'N/A'}</li>
                      <li><strong>Enclosure Color</strong></li>
                      <li>{DeviceEnclosureColor || 'N/A'}</li>
                      <li><strong>FMIP</strong></li>
                      <li>{FMIP || 'N/A'}</li>
                      <li><strong>LCD Resolution</strong></li>
                      <li>{LCDResolution || 'N/A'}</li>
                      <li><strong>Screen Size</strong></li>
                      <li>{LCDSize || 'N/A'}</li>
                      <li><strong>FMIP</strong></li>
                      <li>{FMIP || 'N/A'}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>




            {/* <div className="col-md-4 px-3">
                  <div className="card-inner">
                    <h2>BANDS<br /><br /></h2>
                    <ul className="text-center">
                      <li>LTE</li>
                      <li>N/A</li>
                      <li>TD-LTE</li>
                      <li>N/A</li>
                      <li>FDD-LTE</li>
                      <li>N/A</li>
                      <li>TD-SCDMA</li>
                      <li>N/A</li>
                      <li>CDMA EV-DO</li>
                      <li>N/A</li>
                      <li>UMTS/HSP</li>
                      <li>N/A</li>
                      <li>GSM/EDGE</li>
                      <li>N/A MHz</li>
                    </ul>
                  </div>
                </div> */}
          </div>

          <div className="row py-5">
            <div className="col-md-12 px-3">
              <div className="card-inner px-5">
                <h2>HARDWARE INSPECTION</h2>

                {testCases.length === 0 || testCases.every(({ Result }) => !Result) ? (
                  <div className="alert alert-danger d-flex align-items-center" role="alert">
                    <i className="fa-solid fa-triangle-exclamation" style={{ fontSize: '24px', marginRight: '10px' }}></i>
                    <span>Data Missing or Incomplete. No test cases scanned or inspected.</span>
                  </div>
                ) : (
                  <>
                    <div className="row">
                      {(() => {
                        // Separate passing/failing test cases
                        const filteredTestCases = testCases.filter(({ Name }) => Name !== "TestCaseFails");

                        return [0, 1, 2].map((colIndex) => (
                          <div className="col-md-4" key={colIndex}>
                            <ul className="text-start">
                              {filteredTestCases
                                .slice(colIndex * 10, (colIndex + 1) * 10)
                                .map(({ Name, Result }) => (
                                  <li key={Name}>
                                    <i
                                      className={`fa-${Result === 'PASS' ? 'regular fa-circle-check' : 'solid fa-ban'}`}
                                    ></i>{' '}
                                    <strong>{formatTestCaseName(Name)}</strong> :{' '}
                                    <span style={{ color: Result === 'PASS' ? 'green' : 'red' }}>
                                      {formatResult(Result)}
                                    </span>
                                  </li>
                                ))}
                            </ul>
                          </div>
                        ));
                      })()}
                    </div>

                    {/* Test Case Failures Summary */}
                    {testCases.map(({ Name }) => Name === "TestCaseFails") && (
                      <div className="mt-4 p-3 border rounded bg-light text-center">
                        <div
                          className="d-flex align-items-center"
                          style={{
                            fontSize: '1.3rem',
                            color: '#4d4d4e',
                            position: 'relative',
                          }}
                        >
                          {/* Passed Test Cases Count */}
                          <div>
                            <strong>✅ Passed Test Cases:</strong>{' '}
                            <span style={{ color: 'green' }}>
                              {testCases.filter(({ Result }) => Result === "PASS").length}
                            </span>
                          </div>

                          {/* Failed Test Cases Count */}
                          <div>
                            <strong>❌ Failed Test Cases:</strong>{' '}
                            <span style={{ color: 'red' }}>
                              {testCases.filter(({ Name }) => Name === "TestCaseFails").length}
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>

          <div className="row py-5">
            <div className="col-md-12 px-3">
              <div className="card-inner px-5">
                <h2>PARTS REPLACED</h2>

                {/* Check if parts data is missing or incomplete */}
                {Object.entries(parts).length === 0 || Object.entries(parts).every(([_, { current, factory }]) => !current || !factory) ? (
                  <div className="alert alert-danger d-flex align-items-center" role="alert">
                    <i className="fa-solid fa-triangle-exclamation" style={{ fontSize: '24px', marginRight: '10px' }}></i>
                    <span>Data Missing or Incomplete. No parts scanned or inspected.</span>
                  </div>
                ) : (
                  <div className="row">
                    {/* Split the parts into two columns */}
                    <div className="col-md-6">
                      <ul className="text-start">
                        {Object.entries(parts)
                          .slice(0, Math.ceil(Object.entries(parts).length / 2))
                          .map(([part, { current, factory, result }]) => (
                            <li key={part}>
                              <i
                                className={`fa-${current === factory ? 'regular fa-circle-check' : 'solid fa-ban'
                                  }`}
                              ></i>{' '}
                              <strong>{formatTestCaseName(part)}</strong> :{' '}
                              <span>{current} </span>
                              {/* Display only if the part is replaced */}
                              {current !== factory && (
                                <>
                                  <span> (Replaced with: {factory}) </span>
                                  <span> - Test Result: </span>
                                  <span
                                    style={{
                                      color: result === 'PASS' ? 'green' : 'red',
                                    }}
                                  >
                                    {result || 'Not available'}
                                  </span>
                                </>
                              )}
                              {/* Show if not replaced */}
                              {current === factory && (
                                <span
                                  style={{
                                    color: 'green',
                                  }}
                                >
                                  - No Replacement
                                </span>
                              )}
                            </li>
                          ))}
                      </ul>
                    </div>

                    <div className="col-md-6">
                      <ul className="text-start">
                        {Object.entries(parts)
                          .slice(Math.ceil(Object.entries(parts).length / 2))
                          .map(([part, { current, factory, result }]) => (
                            <li key={part}>
                              <i
                                className={`fa-${current === factory ? 'regular fa-circle-check' : 'solid fa-ban'
                                  }`}
                              ></i>{' '}
                              <strong>{formatTestCaseName(part)}</strong> :{' '}
                              <span>{current} </span>
                              {/* Display only if the part is replaced */}
                              {current !== factory && (
                                <>
                                  <span> (Replaced with: {factory}) </span>
                                  <span> - Test Result: </span>
                                  <span
                                    style={{
                                      color: result === 'PASS' ? 'green' : 'red',
                                    }}
                                  >
                                    {result || 'Not available'}
                                  </span>
                                </>
                              )}
                              {/* Show if not replaced */}
                              {current === factory && (
                                <span
                                  style={{
                                    color: 'green',
                                  }}
                                >
                                  - No Replacement
                                </span>
                              )}
                            </li>
                          ))}
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

        </div>
      </section>

      <footer>
        <div className="container">
          <div className="row py-5 align-items-center">
            <div className="col-md-8 text-start">
              <img src={logo} className="img-fluid flogo" alt="fogo" />
              {/* <div className="socials">
                    <img src={goog} className="img-fluid" alt="goog" />
                    <img src={fac} className="img-fluid" alt="fac" />
                    <img src={lin} className="img-fluid" alt="lin" />
                    <img src={pin} className="img-fluid" alt="pin" />
                    <img src={ins} className="img-fluid" alt="ins" />
                  </div> */}
            </div>
            <div className="col-md-4">
              <h3>For Queries: </h3>
              <ul>
                <li>
                  <img src={a} className="img-fluid" alt="a" />
                  <a href="mailto:info@GearVu.com">info@GearVu.com</a>
                </li>
                <li>
                  <img src={mob} className="img-fluid" alt="mob" />
                  <a href="tel:18552168091">1.855.216.8091</a>
                </li>
                <li>
                  <img src={globe} className="img-fluid" alt="globe" />
                  <a href="https://GearVu.com" target="_blank" rel="noopener noreferrer">GearVu.com</a>
                </li>
                <li>
                  <img src={lin} className="img-fluid" alt="lin" />
                  <a href="https://www.linkedin.com/company/GearVu" target="_blank" rel="noopener noreferrer">GearVu</a>
                </li>
              </ul>
            </div>


          </div>
        </div>
      </footer>
      <div className="footer-bottom">
        <p>©2025, GearVu®  All rights reserved.</p>
      </div>
    </div>
  );
}

export default WebHookReport;


